import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16.001",
  height: "16",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#066542" }, [
      _createElementVNode("path", { d: "M4.06 1.91a.41.41 0 0 0-.41-.41H1.91a.41.41 0 0 0-.41.41v12.18c0 .226.184.41.41.41h1.74a.41.41 0 0 0 .41-.41zm1.5 12.18A1.91 1.91 0 0 1 3.65 16H1.91A1.91 1.91 0 0 1 0 14.09V1.91A1.91 1.91 0 0 1 1.91 0h1.74a1.91 1.91 0 0 1 1.91 1.91zM14.501 1.91a.41.41 0 0 0-.41-.41h-1.74a.41.41 0 0 0-.41.41v12.18c0 .226.184.41.41.41h1.74a.41.41 0 0 0 .41-.41zm1.5 12.18a1.91 1.91 0 0 1-1.91 1.91h-1.74a1.91 1.91 0 0 1-1.91-1.91V1.91A1.91 1.91 0 0 1 12.351 0h1.74a1.91 1.91 0 0 1 1.91 1.91z" })
    ], -1)
  ]))]))
}
export default { render: render }